export enum UserRole {
	AVOCAT = 'AVOCAT',
	ADMINEMDF = 'ADMINEMDF',
	SUPERADMIN = 'SUPERADMIN',
	SYSADMIN = 'SYSADMIN',
	NIVEAU1 = 'NIVEAU1',
	NIVEAU2 = 'NIVEAU2',
	NIVEAU3 = 'NIVEAU3',
	RB = 'RB',
	FICHIERAVOCAT = 'FICHIERAVOCAT',
	BOB ='BOB'
}

export enum UserGroup {
	Niveau1 = 'Groupe Niveau1',
	Niveau2 = 'Groupe Niveau2',
	Niveau3 = 'Groupe Niveau3',
	AdminEmdf = 'Groupe Admin Emdf',
	Avocat = 'Groupe Avocat',
	Admin = 'Groupe Admin'
}
